const benefits = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
    title: 'サービスをわかりやすく伝えられる',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
      </svg>
    ),
    title: '問い合わせや予約につなげやすい',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    ),
    title: '広告やSNSの案内先にしやすい',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
    title: 'キャンペーンや採用にも使いやすい',
  },
];

export default function LpBenefits() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-14">
          <span className="section-label">LPのメリット</span>
          <h2 className="section-title">
            LPがあると、伝えたいことを
            <br className="hidden md:block" />
            1ページでわかりやすく届けやすくなります
          </h2>
          <p className="section-subtitle">
            LPは、サービス内容や強みを整理して、問い合わせ・予約・応募などの行動につなげやすくするためのページです。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 bg-white rounded-lg p-6 border border-border"
            >
              <div className="shrink-0 w-10 h-10 rounded-md bg-surface flex items-center justify-center text-primary">
                {item.icon}
              </div>
              <p className="text-base font-medium text-primary pt-1.5">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
